export default __webpack_public_path__ + "assets/reserve.408298f0.png";